import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'wallet-card',
  name: '钱包卡片',
  icon: '包',
  group: '国学组件',
  description: '展示星豆余额、赠送余额和积分概览。',
  defaultProps: {
    title: '我的钱包',
    buttonText: '查看明细',
    link: '/pages/guoxue/wallet'
  }
}
